import React from 'react';

import Money from 'components/Money';

import './styles.css';

const RemainingCredit = ({remainingCredit}) => {
  return (
    <div className="RemainingCredit">
      <div className="section">
        <div className="header">Remaining Credit</div>
        <div className="value">
          <Money amount={remainingCredit} />
        </div>
      </div>
    </div>
  );
};

export default RemainingCredit;
